import { TSelectOption } from '@/common/types/select';

import { CostTypes, IndicatorTypes, SelectTypes, ShowSections } from '../types/common-aggregated';
import { ProductsTradeDirections } from '../types/foreign-trade-by-products';

export const INDICATOR_TYPE_FILTER_OPTIONS: TSelectOption<IndicatorTypes>[] = [
  {
    value: IndicatorTypes.PRICE,
    label: 'Стоимость',
  },
  {
    value: IndicatorTypes.WEIGHT,
    label: 'Вес',
  },
  {
    value: IndicatorTypes.PRICE_AND_WEIGHT,
    label: 'Стоимость и вес',
  },
];

export const COST_TYPE_FILTER_OPTIONS: TSelectOption<CostTypes>[] = [
  {
    value: CostTypes.DOLLARS,
    label: 'Долл.',
  },
  {
    value: CostTypes.THOUSANDS_OF_DOLLARS,
    label: 'Тыс. долл.',
  },
  {
    value: CostTypes.MILLIONS_OF_DOLLARS,
    label: 'Млн долл.',
  },
  {
    value: CostTypes.BILLIONS_OF_DOLLARS,
    label: 'Млрд долл.',
  },
];

export const SHOW_SECTION_FILTER_OPTIONS: TSelectOption<ShowSections>[] = [
  {
    value: ShowSections.PRODUCTS,
    label: 'Товары/Страны',
  },
  {
    value: ShowSections.COUNTRIES,
    label: 'Страны/Товары',
  },
];

export const SELECT_TYPE_FILTER_OPTIONS: TSelectOption<SelectTypes>[] = [
  {
    value: SelectTypes.PERIOD,
    label: 'За период',
  },
  {
    value: SelectTypes.CUMULATIVE_TOTAL,
    label: 'Нарастающим итогом',
  },
];

export const PRODUCTS_TRADE_DIRECTION_FILTER_OPTIONS: TSelectOption<ProductsTradeDirections>[] = [
  {
    value: ProductsTradeDirections.EXPORT,
    label: 'Экспорт',
  },
  {
    value: ProductsTradeDirections.IMPORT,
    label: 'Импорт',
  },
  {
    value: ProductsTradeDirections.TURNOVER,
    label: 'Оборот',
  },
];
